import Vue from 'vue'
import VueIntercom from '@mathieustan/vue-intercom'
const appId = process.env.VUE_APP_INTERCOM_APP_ID

if (process.env.VUE_APP_INTERCOM_APP_ID) { //após testes mudar condição para production
    Vue.use(VueIntercom, { appId })
}
